module.exports = __webpack_public_path__ + "img/icon-home.c3039a36.svg";